import ImmutableModel from '../immutable.model';

/**
 * A reservable time slot from the backend.
 */
class NextReservationSlot extends ImmutableModel {
  /**
   * @param {Number} id
   * @param {Moment} start_time
   * @param {Moment} end_time
   * @param {Number} location_id
   * @param {String} location_name
   * @param {Number} service_id
   * @param {String} service_name
   * @param {Person} person
   */
  constructor(id, start_time, end_time, location_id, location_name, service_id, service_name, person) {
    super();

    this.id = id;
    this.start_time = start_time;
    this.end_time = end_time;
    this.location = {
      id: location_id,
      name: location_name
    };
    this.service = {
      id: service_id,
      name: service_name
    };
    this.person = person;

  }

  /**
   * Duration of the slot in minutes.
   * @returns {Number}
   */
  get duration() {
    return this.end_time.diff(this.start_time, 'minutes');
  }

  copy() {
    return new NextReservationSlot(
      this.id,
      this.start_time,
      this.end_time,
      this.location.id,
      this.location.name,
      this.service.id,
      this.service.name,
      this.person
    );
  }
}

export default NextReservationSlot;



// WEBPACK FOOTER //
// ./src/app/common/models/next-reservation-slot.model.js